import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import { NotificationBell } from './NotificationBell';

const TITLE_KEYS = {
  '/': 'dashboard.title',
  '/employees': 'employees.title',
  '/employee-lifecycle': 'lifecycle.title',
  '/org-chart': 'orgChart.title',
  '/leaves': 'leaves.title',
  '/expense-reports': 'expenses.title',
  '/personal-finance': 'personalFinance.title',
  '/awards': 'awards.title',
  '/settings': 'settings.title',
  '/records': 'legajo.heroTitle',
  '/documents': 'comingSoon.documents.title',
  '/employee-portal': 'portal.title',
  '/attendance': 'attendance.title',
  '/payroll-receipts': 'comingSoon.payrollReceipts.title',
  '/communications': 'communications.title',
  '/notifications': 'notifications.title',
  '/feed': 'feedWall.title',
  '/chat': 'chatPage.title',
  '/compliance': 'comingSoon.compliance.title',
  '/performance': 'evaluations.heroTitle',
  '/recruiting': 'comingSoon.recruiting.title',
  '/training': 'trainings.heroTitle',
  '/surveys': 'climate.heroTitle',
  '/tasks': 'comingSoon.tasks.title',
  '/reports': 'reportsPage.title',
  '/people-intelligence': 'pi.title',
};

const SUBTITLE_KEYS = {
  '/': 'dashboard.subtitle',
  '/employees': 'employees.subtitle',
  '/employee-lifecycle': 'lifecycle.subtitle',
  '/org-chart': 'orgChart.subtitle',
  '/leaves': 'leaves.subtitle',
  '/expense-reports': 'expenses.subtitle',
  '/personal-finance': 'personalFinance.subtitle',
  '/awards': 'awards.subtitle',
  '/settings': 'settings.subtitle',
  '/records': 'legajo.heroSubtitle',
  '/documents': 'comingSoon.genericSubtitle',
  '/employee-portal': 'portal.subtitleHeader',
  '/attendance': 'attendance.subtitle',
  '/payroll-receipts': 'comingSoon.genericSubtitle',
  '/communications': 'communications.subtitle',
  '/notifications': 'notifications.subtitle',
  '/feed': 'feedWall.lead',
  '/chat': 'chatPage.lead',
  '/compliance': 'comingSoon.genericSubtitle',
  '/performance': 'evaluations.heroLead',
  '/recruiting': 'comingSoon.genericSubtitle',
  '/training': 'trainings.heroLead',
  '/surveys': 'climate.heroLead',
  '/tasks': 'comingSoon.genericSubtitle',
  '/reports': 'reportsPage.lead',
  '/people-intelligence': 'pi.subtitle',
};

export function Header({ onMenuClick }) {
  const { t, locale, setLocale, toggleTheme, theme, authMe, isProductionUi } = useApp();
  const location = useLocation();
  const path = location.pathname;
  const titleKey = TITLE_KEYS[path] || 'dashboard.title';
  const subtitleKey = SUBTITLE_KEYS[path];

  return (
    <header className="app-header">
      <div className="app-header__left">
        <button
          type="button"
          className="icon-btn app-header__menu-btn"
          aria-label="Menu"
          onClick={onMenuClick}
        >
          <span className="hamburger" />
        </button>
        <div className="app-header__titles">
          <nav className="app-header__crumb" aria-label="Breadcrumb">
            <Link to="/">{t('header.breadcrumbHome')}</Link>
          </nav>
          <h1 className="app-header__title">{t(titleKey)}</h1>
          {subtitleKey ? <p className="app-header__subtitle">{t(subtitleKey)}</p> : null}
        </div>
      </div>
      <div className="app-header__actions">
        <NotificationBell />
        <span className="online-pill" title={t('header.onlineTitle')}>
          <span className="online-pill__dot" aria-hidden />
          {t('header.online')}
        </span>
        {!isProductionUi ? (
          <span className="flow-pill flow-pill--compact" title={t('header.flowPreparedTitle')}>
            {t('header.flowPreparedShort')}
          </span>
        ) : null}
        {!isProductionUi ? <span className="header-badge-demo">{t('header.demoBadge')}</span> : null}
        <div className="lang-toggle" role="group" aria-label="Language">
          <button
            type="button"
            className={locale === 'es' ? 'lang-toggle__btn is-active' : 'lang-toggle__btn'}
            onClick={() => setLocale('es')}
          >
            ES
          </button>
          <button
            type="button"
            className={locale === 'en' ? 'lang-toggle__btn is-active' : 'lang-toggle__btn'}
            onClick={() => setLocale('en')}
          >
            EN
          </button>
        </div>
        <button
          type="button"
          className="theme-icon-btn"
          onClick={toggleTheme}
          aria-label={theme === 'dark' ? t('header.themeSwitchToLight') : t('header.themeSwitchToDark')}
          title={theme === 'dark' ? t('header.themeSwitchToLight') : t('header.themeSwitchToDark')}
        >
          <span className="theme-icon-btn__glyph" aria-hidden>
            {theme === 'dark' ? '☀' : '☾'}
          </span>
        </button>
        <div className="user-chip" title={authMe?.email || ''}>
          <span className="user-chip__avatar">{(authMe?.name || 'U').slice(0, 1).toUpperCase()}</span>
          <span className="user-chip__name">{authMe?.name || t('header.userFallback')}</span>
        </div>
      </div>
    </header>
  );
}
